/**
 * RMS module route manifest.
 *
 * Each route is mounted under the shell's main-layout when this module is active
 * (selected by APP_CODE). The shell never knows about RMS pages beyond this file.
 */
export default {
  code: 'rms',
  routes: [
    {
      // Profil détaillé de l'utilisateur connecté (clic sur l'avatar du tiroir,
      // cf. NavigationService.goToPersonalProfil) : statique, donc accessible
      // sans droit sur le menu « Utilisateurs » du produit.
      path: '/rms-my-profile/:userId',
      name: 'rms-my-profile',
      component: () => import('@rms-pages/rms/rmsUserDetail.vue'),
      meta: { appCode: 'rms', myProfile: true, appCodes: ['rms'] }
    },
    {
      path: '/rms-portal',
      name: 'rms-portal',
      component: () => import('@rms-pages/portal/rmsPortal.vue'),
      meta: { appCode: 'rms', title: 'RMS' }
    },
  ]
}
